import UpdateCommentLessonsRequestModelBase from '../_generated/modelBases/update-comment-lessons-request-model-base';

export default class UpdateCommentLessonsRequestModel extends UpdateCommentLessonsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
